// app/translate/translate.pipe.ts

import { Injectable, Pipe, PipeTransform } from "@angular/core";

// tslint:disable-next-line:pipe-naming
@Pipe({
  name: "currencymap", // currency is already used, so we must use hcurrency
  standalone: true,
  // impure pipe - the pipe is called every time change detection runs (which is usually quite often).
  // pure: false // impure pipe, update value when we change language
  pure: true, // better UI performance
})
@Injectable({
  providedIn: "root", // ✅ or 'any'
})
export class CurrencyMapPipe implements PipeTransform {
  private currencyMap = {
    CZK: "Kč",
    EUR: "€",
    USD: "$",
  };

  transform(currencyIsoCode: string): any {
    let symbol = this.currencyMap[currencyIsoCode];

    return symbol;
  }
}
